import { render, staticRenderFns } from "./datascreening.vue?vue&type=template&id=401bd464&scoped=true&"
import script from "./datascreening.vue?vue&type=script&lang=js&"
export * from "./datascreening.vue?vue&type=script&lang=js&"
import style0 from "./datascreening.vue?vue&type=style&index=0&id=401bd464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bd464",
  null
  
)

export default component.exports